import {
  HTTP_STATUS_FORBIDDEN,
  HTTP_STATUS_NOT_FOUND,
} from '../../constants/api'

export const BROWSER_TAB_TITLE_IDWELL = 'iDWELL'

export const BROWSER_TAB_TITLE_SEPARATOR = ' | '

export const BROWSER_TAB_LOADING_TEXT_KEY = 'BrowserTab.LoadingTextKey'

export const BROWSER_TAB_TITLE_MAX_PAGE_TITLE_LENGTH = 65

export const BROWSER_TAB_ERROR_TITLE_BY_STATUS = {
  [HTTP_STATUS_FORBIDDEN]: 'BrowserTab.AccessDeniedTextKey',
  [HTTP_STATUS_NOT_FOUND]: 'BrowserTab.NotFoundTextKey',
}
